// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Hkii","head":"Table_head__1Be0y","col":"Table_col__suZ4Y"};